import "../styles/inlistkachel.scss";
import * as CubeTrackingAB from "./tracking/cube/AbTestTracking";
import * as CubeTrackingAK from "./tracking/cube/AktionskommunikationsTracking";
import { inlisttile, middle } from "./CAMPWindow";

class Inlistkachel extends HTMLElement {
    private observer: IntersectionObserver;
    private alreadyTracked: boolean;
    private internalEventsAbortController: AbortController | undefined;
    private kampagneName: string | undefined | null;
    private abTestHeaderValue: string | undefined | null;
    private abTestHeaderName: string | undefined | null;

    constructor() {
        super();
        this.observer = new IntersectionObserver(this.handleObservationEvent.bind(this), { threshold: 0.9 });
        this.alreadyTracked = false;
    }

    connectedCallback(): void {
        const kachel = this.querySelector<HTMLDivElement>('[data-select="inlistkachel"]');
        this.kampagneName = kachel?.getAttribute("data-kampagne-name");
        this.abTestHeaderValue = kachel?.getAttribute("data-abtest-value");
        this.abTestHeaderName = kachel?.getAttribute("data-abtest-name");
        this.internalEventsAbortController = new AbortController();
        const signal = this.internalEventsAbortController.signal;
        this.setupLinkClick(signal);
        this.observer.observe(this);
        CubeTrackingAB.trackView(this.abTestHeaderValue, this.abTestHeaderName);
    }

    private handleObservationEvent(entries: IntersectionObserverEntry[]): void {
        entries.forEach((entry) => {
            if (entry.isIntersecting && !this.alreadyTracked && this.kampagneName) {
                CubeTrackingAK.trackView(this.kampagneName, middle, inlisttile);
                this.alreadyTracked = true;
            }
        });
    }

    private setupLinkClick(signal: AbortSignal): void {
        const link = this.querySelector<HTMLAnchorElement>('[data-select="link"]');
        if (link) {
            link.addEventListener(
                "click",
                (event) => {
                    const target = event.target as HTMLAnchorElement;
                    if (this.kampagneName && target) {
                        CubeTrackingAK.trackLinkClick(this.kampagneName, target.href, middle, inlisttile);
                    }
                },
                { signal },
            );
        }
    }

    disconnectedCallback(): void {
        this.observer.disconnect();
    }
}

customElements.define("camp-inlistkachel", Inlistkachel);
